import Axios from "../../api/Axios";
const BASE_URL = "GRNNonInv/";
export const Endpoint = {
    GetGRN: "GetGRN",
    GetGRNDataId: "GetGRNDataId",
    DesignDetailGrid: "DesignDetailGrid",
    SaveNonInvGRN: "SaveNonInvGRN",
    GetSupplierData: "GetSupplierData",
    GetPaymentDate: "GetPaymentDate",
    GetProductdetlGRN: "GetProductdetlGRN",
};


export const createAPIEndpointGRNNonINV = () => {
    return { get: (Endpoint) => Axios.get(BASE_URL + Endpoint),
        post: (Endpoint,data)=> Axios.post(BASE_URL+Endpoint,data)
    };
};
